import { c as _c } from "react/compiler-runtime";
import React from 'react';
import IconSwatchRequest from 'components/icons/iconSwatchRequest';
const SwatchRequestIcon = t0 => {
  const $ = _c(2);
  const {
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = <IconSwatchRequest width="36" height="36" color={color} />;
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default SwatchRequestIcon;